import * as React from "react";
import { useId } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTree = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsxs("svg", {
		fill: "none",
		viewBox: "0 0 32 32",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M16 3.5 22.5 11.5H20.5L25 17.5H22.5L27.5 24H4.5L9.5 17.5H7L11.5 11.5H9.5L16 3.5ZM16 24v3.5",
				stroke: "white",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 5.5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16 3.5 22.5 11.5H20.5L25 17.5H22.5L27.5 24H4.5L9.5 17.5H7L11.5 11.5H9.5L16 3.5Z",
				style: { fill: "var(--sticker-pastel,#D1D7B3)" }
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16 3.5 22.5 11.5H20.5L25 17.5H22.5L27.5 24H4.5L9.5 17.5H7L11.5 11.5H9.5L16 3.5ZM16 24v3.5",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5,
				style: { stroke: "var(--sticker-dark,#5F6F27)" }
			})
		]
	});
};
export default SvgTree;
